export default __webpack_public_path__ + "static/media/T17.08071b63.JPG";